// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1hVUW","list":"styles_list__1IpUB"};